import { ACTIVITY_STAGES } from "../activitySectionUtils";
import { getVisibleBuilderSections } from "./activityBuilderConfig.v2";

/** Map server current_stage (legacy or sequential) to v2 unlock progress (1–6, or 7 when submitted). */
export const mapLegacyStageToUnlockOrder = (savedStage, isFreeBooking = false) => {
  const stage = Number(savedStage) || 1;

  // New v2 sequential values written by the builder
  if (stage >= 1 && stage <= 7) {
    return stage;
  }

  // Legacy enum values from the old multi-tab builder
  if (stage <= ACTIVITY_STAGES.GENERAL) return 1;
  if (stage <= ACTIVITY_STAGES.TICKETS) return 2;
  if (stage < ACTIVITY_STAGES.ITINERARY) return 2;
  if (stage <= ACTIVITY_STAGES.ITINERARY) return 3;
  if (stage <= ACTIVITY_STAGES.PRICING) return isFreeBooking ? 3 : 4;
  if (stage <= ACTIVITY_STAGES.FAQ) return isFreeBooking ? 4 : 5;
  if (stage <= ACTIVITY_STAGES.TERMS) return isFreeBooking ? 5 : 6;
  return isFreeBooking ? 6 : 7;
};

export const getActivityCompletedUnlockOrder = (savedStage, isFreeBooking = false) =>
  mapLegacyStageToUnlockOrder(savedStage, isFreeBooking);

export const getSectionUnlockOrder = (sectionId, isFreeBooking = false) => {
  const section = getVisibleBuilderSections(isFreeBooking).find((item) => item.id === sectionId);
  return section?.unlockOrder ?? 1;
};

/** Next stored unlock order after explicitly saving a section. */
export const getNextUnlockOrderAfterSave = (sectionId, isFreeBooking = false) => {
  const sections = getVisibleBuilderSections(isFreeBooking);
  const index = sections.findIndex((item) => item.id === sectionId);
  if (index < 0) return 1;

  const nextSection = sections[index + 1];
  if (nextSection) return nextSection.unlockOrder;

  return sections[index].unlockOrder + 1;
};

export const isActivityBuilderSectionAccessible = (
  sectionUnlockOrder,
  completedUnlockOrder,
  hasActivityId,
  isResumeEdit = false
) => {
  if (isResumeEdit) return true;
  if (!hasActivityId) return sectionUnlockOrder === 1;
  const progress = Number(completedUnlockOrder) || 1;
  return sectionUnlockOrder <= progress;
};

export const isActivitySectionSaved = (sectionUnlockOrder, completedUnlockOrder) =>
  Number(completedUnlockOrder) > Number(sectionUnlockOrder);

export const getActivityResumeSectionId = (savedStage, isFreeBooking = false) => {
  const completedUnlockOrder = getActivityCompletedUnlockOrder(savedStage, isFreeBooking);
  const sections = getVisibleBuilderSections(isFreeBooking);
  const current =
    sections.find((item) => item.unlockOrder === completedUnlockOrder) ||
    sections.find((item) => item.unlockOrder > completedUnlockOrder) ||
    sections[sections.length - 1];
  return current?.id || "general";
};
